// extracted by mini-css-extract-plugin
export default {"page":"BY-z","cartModal":"CY-z","checkout":"DY-z","placeholder":"EY-z","account":"FY-z"};